import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';

const PendingFeesList = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  
  const [showCancelForm, setShowCancelForm] = useState(false);
const [cancelReason, setCancelReason] = useState('');
  const [cancelNotes, setCancelNotes] = useState('');
  const [mode, setMode] = useState('');


  useEffect(() => {
   
console.log("Logged in as:", user?.name);
    fetchStudentData();
  }, [user]);

  const fetchStudentData = async () => {
    try {
      const response = await axios.get(AppStrings.PendingFeeDetails);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        setData(result);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayClick = async (row) => {
    const feeType = row.ADDFEES;
    const className = row.CLASS;
    const type = 'N';
    const AdmissionID=row.STUDENT_ID

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //const url = `https://school.agnisofterp.com/agni/fees/list?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}`;
    const url = AppStrings.FeesDetailGet+`?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}&ADMISSIONID=${AdmissionID}`;

    try {
      const response = await axios.get(url);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
         setMode('pay');
        setSelectedRow(row);
        setFeeDetails(withEditable);
      } else {
        alert(`No fee records found for ${row.NAME}`);
        setFeeDetails([]);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      alert("Failed to fetch fee details.");
    }
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel =  async (row) => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);

  const getInitials = (fullName) => {
  if (!fullName) return '';
  const names = fullName.trim().split(' ');
  if (names.length === 1) return names[0][0].toUpperCase();
  return (names[0][0] + names[names.length - 1][0]).toUpperCase();
};


const colors = [
  '#4a90e2', // blue
  '#e94e77', // pinkish
  '#f6b93b', // yellow
  '#6ab04c', // green
  '#30336b', // dark blue
  '#eb4d4b', // red
  '#22a6b3', // turquoise
];

function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}
  //  const [firstName, setFirstName] = useState("");
  //       const [lastName, setLastName] = useState("");
        
    const handleSubmit = async () => {
      const payload = {
        student: {
          id: selectedRow.STUDENT_ID,
          admissionDate: admissionDate,
          type: selectedRow.ADDFEES,
        },
        fees: feeDetails .filter(({ current, discount }) => {
          const paid = parseFloat(current) || 0;
          const off = parseFloat(discount) || 0;
          return paid + off > 0;
        }).map(({ TYPE, FEES,current, discount }) => ({
          TYPE,
          FEES,
          current,
          discount
        }))
      };
  
      try {
        console.log('haiiii');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.StudentFeesEntry, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
        console.log('haiiii22');
        alert(result.message || "Data saved successfully!");
        handleCancel();
        fetchStudentData();
        console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };

  return (
    <div style={{ padding: '0px' }}>
      <h2>Pending Student List</h2>

      {loading && <p>Loading data...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <input
              type="text"
              placeholder="Search By Student Name/Student Id"
              name="STUDENTNAME"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              className="input"
            />
            <br />
          </div>
        </div>
      </div>

      {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: '440px', overflowY: 'auto'}}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                 <th style={{ ...headerCellStyle, width: '20px' }}></th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Name</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Parent Details</th>
                
                <th style={{ ...headerCellStyle, width: '100px' }}>Type</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Tuition Due</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Transport Due</th>
                <th style={{ ...headerCellStyle, width: '120px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                  row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
                )
                .map((row, index) => (
                  <tr key={index}>
                      <td style={cellStyle}><div style={{ 
  ...avatarStyle, 
  backgroundColor: stringToColor(row.NAME) 
}}>
    {getInitials(row.NAME)}
  </div></td>
                    <td style={cellStyle}>
                      <div>
    {row.NAME}
  </div>
  <div style={{ fontSize: '10px', marginTop: '4px' }}>
    {"["+row.CLASS_SEC+"] Id : "+row.STUDENT_ID}
  </div></td>
                   
                    <td style={cellStyle}><div>
    {row.PARENTNAME}
  </div>
  <div style={{ fontSize: '10px', marginTop: '4px' }}>
    {row.PARENTMOBILE}
  </div></td>
                    <td style={cellStyle}>
                       {row.ADDFEES == 'MET' ? 'MATRIC' : row.ADDFEES}
                      </td>
                    <td style={cellStyle}>{row.TUITION_DUE}</td>
                    <td style={cellStyle}>{row.TRANSPORT_DUE}</td>
                    <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                      <button className="GridButton" onClick={() => {
  setSelectedRow(row); 
  setMode('cancel');
  setShowCancelForm(true); 
}}>Cancel</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
 {/* <div style={{
        ...slidePanelStyle1,
        right: selectedRow ? '0px' : '-100%',
      }}> */}
      {selectedRow  && mode === 'pay'  && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
        <>
            <h3>{selectedRow.STUDENT_ID+'-'+selectedRow.NAME+'-'+selectedRow.CLASS}</h3>
            <div style={{ marginTop: '15px', textAlign: 'left', fontWeight: 'bold', fontSize: '16px' }}>
            <div className="row">
        <div className="col-25">
        <div className="col-25">
        
            <div className="coolinput">
          {/* <label for="input" class="text">Admission Date:</label> */}
            <input
              required
              type="date"
              name="DOADM"
              autoComplete="off"
              className="input"
              value={admissionDate}
              onChange={(e) => setAdmissionDate(e.target.value)}
            />
            
            </div> 
          </div> 
          </div>
          </div>
                </div>
            {feeDetails.length > 0 ? (
              <table style={{ width: '100%', marginTop: '10px',overflowY: 'auto', border: '1px solid #ccc',borderCollapse: 'collapse',   tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={headerCellStyle}>Fee Type</th>
                    <th style={headerCellStyle}>Fee Amount</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Paid</th>
                  </tr>
                </thead>
                <tbody>
                  {feeDetails.map((fee, idx) => {
                    const feeAmount = parseFloat(fee.FEES) || 0;
                    const discount = parseFloat(fee.discount) || 0;
                    const payable = feeAmount - discount;

                    return (
                      <tr key={idx}>
                        <td style={cellStyle}>{fee.TYPE}</td>
                        <td style={cellStyle}>{fee.FEES}</td>
                        <td style={cellStyle}>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Enter Discount"
                            value={fee.discount}
                            onChange={(e) => handleInputChange(idx, 'discount', e.target.value)}
                            className="input"
                          />
                          </div>
                        </td>
                        <td style={cellStyle}>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Enter Paid Amount"
                            value={fee.current}
                            onChange={(e) => handleInputChange(idx, 'current', e.target.value)}
                            className="input PayInPut"
                          />
                          </div>
                          <div style={{ fontSize: '0.8em', color: '#555' }}>
                            Payable: ₹{payable.toFixed(2)}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            
            ) : (
              <p>No fee data available.</p>
            )}
             <div style={{ marginTop: '15px', textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  Total Paid Amount: ₹{totalPaid.toFixed(2)}
                </div>
                <button onClick={handleSubmit} style={{ marginTop: '15px' }}>Save</button>
            <button onClick={handleCancel} style={{ marginTop: '15px' }}>Close</button>
            </>
        </div> </div>
      )}


{showCancelForm && (
  <div style={modalOverlayStyle}>
    <div style={modalStyle}>
      <h3>Cancel Payment for {selectedRow?.NAME}</h3>
      <form onSubmit={(e) => {
        e.preventDefault();
        console.log("Cancelled Reason:", cancelReason);
        console.log("Notes:", cancelNotes);

        // You can send this data to an API here if needed

        setShowCancelForm(false);
        setSelectedRow(null);
        setFeeDetails([]);
        setCancelReason('');
        setCancelNotes('');
      }}>
        <div style={{ marginBottom: '10px', textAlign: 'left' }}>
          <label>Reason for Cancel:</label>
          <input
            type="text"
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            required
            className="input"
          />
        </div>

        <div style={{ marginBottom: '10px', textAlign: 'left' }}>
          <label>Additional Notes:</label>
          <textarea
            value={cancelNotes}
            onChange={(e) => setCancelNotes(e.target.value)}
            rows={3}
            className="input"
            placeholder="Optional"
          />
        </div>

        <div style={{ textAlign: 'right' }}>
          <button type="submit" style={{ marginRight: '10px' }}>Submit</button>
          <button type="button" onClick={() => setShowCancelForm(false)}>Close</button>
        </div>
      </form>
    </div>
  </div>
)}


      </div>
  
  );
};

// Styles
const headerCellStyle = {
//  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const cellStyle = {
  //border: '1px solid #ddd',
padding: '2px',
  fontSize:'13px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  textAlign: 'center',
};


const avatarStyle = {
  width: '36px',
  height: '36px',
  backgroundColor: '#4a90e2',
  borderRadius: '50%',
  color: 'white',
  fontWeight: 'bold',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
};

// const slidePanelStyle1 = {
//   position: 'fixed',
//   top: 0,
//   right: '-100%',
//   width: '500px',
//   height: '100%',
//   backgroundColor: '#e6f7ff',
//   boxShadow: '-2px 0 10px rgba(0,0,0,0.3)',
//   padding: '20px',
//   overflowY: 'auto',
//   transition: 'right 0.3s ease-in-out',
//   zIndex: 999,
// };




export default PendingFeesList;
